import isEmpty from 'lodash/isEmpty';
import { eventChannel } from 'redux-saga';
import { call, take, cancelled, put, select } from 'redux-saga/effects';

import * as sessionRefresh from './session-refresh-req';
import { REFRESH_SESSION_INTERVAL } from '../../constants/env';
import { loggedUserSelector } from '../../redux/context/selectors';

const interval = REFRESH_SESSION_INTERVAL || 5 * 60 * 1000;

function makeInterval() {
  return eventChannel(emitter => {
    const iv = setInterval(() => emitter(true), interval);
    return () => clearInterval(iv);
  });
}

export default function* refreshSessionIntervalSaga() {
  const isLoggedUser = yield select(loggedUserSelector);

  if (!isEmpty(isLoggedUser)) {
    const chan = yield call(makeInterval);

    try {
      while (true) {
        yield take(chan);
        yield put(sessionRefresh.actions.send());
      }
    } finally {
      if (yield cancelled()) {
        chan.close();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/auth/refresh-session-interval-saga.js